import { render, staticRenderFns } from "./EditCareProtocolDialog.vue?vue&type=template&id=931ca34c&v-slot%3Amodal-body=true&"
import script from "./EditCareProtocolDialog.vue?vue&type=script&lang=js&"
export * from "./EditCareProtocolDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports